export default {"featuredMenu":"uAlIV","featuredItem":"vH7sm","featuredIcon":"ZCOLc"};